import { Card, Form, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useParams } from "react-router";
import { useEffect } from "react";
import { sectorService } from "../../../services/sector.service";
import CardFooterAction from "../../../components/CardFooterAction";
import { useGetDetailApi, useStoreUpdateApi } from "../../../hooks/useApi";
import CustomTextInput from "../../../components/CustomTextInput";

export default function SectorForm() {
  const { id } = useParams();
  const [form] = useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { data } = useGetDetailApi({
    id,
    serviceFn: sectorService.findById,
    queryKey: ["sector"],
  });

  const { storeMutation, updateMutation } = useStoreUpdateApi({
    service: sectorService,
    form: form,
    messageApi: messageApi,
    queryKey: "sector",
    route: "/master-data/sector",
  });

  useEffect(() => {
    if (id && data) {
      form.setFieldsValue(data);
    }
  }, [form, id, data]);

  const isPending = storeMutation.isLoading || updateMutation.isLoading;

  const handleSubmit = (values) => {
    if (!id) {
      storeMutation.mutate(values);
    } else {
      updateMutation.mutate({ id, data: values });
    }
  };

  return (
    <>
      {contextHolder}
      <Card
        title={(id ? "Ubah" : "Tambah") + " Sektoral & Jabatan"}
        actions={[
          <CardFooterAction
            key={"submit"}
            route={"/master-data/sectoral-position"}
            onClick={() => form.submit()}
            loading={isPending}
            primaryText="Simpan"
            secondaryText="Batal"
          />,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <CustomTextInput
            label="Nama Sektoral"
            name="name"
            rules={[{ required: true, message: "Nama Sektoral harus diisi" }]}
            disabled={isPending}
          />
        </Form>
      </Card>
    </>
  );
}
